/*
 腾讯视频APP接口模块
 */

import util from './util';
import { createNormalizer } from './urlFactory';
import Version from './Version';
import env from './env';
import extend from 'lodash-es/extend';
import isArray from 'lodash-es/isArray';
import Storage from './Storage/index';

const ua = navigator.userAgent;
const isIOS = ua.indexOf('iPhone') !== -1;
const isIPad = ua.indexOf('iPad') !== -1;
const isAdr = ua.indexOf('Android') !== -1;
const urlNormalize = createNormalizer();

export const tenvideoReady = (fun) => {
  fun = fun || function () {};
  if (typeof TenvideoJSBridge === 'undefined') {
    if (document.addEventListener) {
      document.addEventListener('onTenvideoJSBridgeReady', fun, false);
    } else if (document.attachEvent) {
      document.attachEvent('onTenvideoJSBridgeReady', fun);
    }
  } else {
    fun();
  }
};

// 用普通的webview打开，多次返回会有关闭按钮。好莱坞的webview没有
export const openUrlCommonActivity = url => new Promise((resolve) => {
  tenvideoReady(() => {
    let absUrl = _getAbsUrl(url);
    try {
      if (/^(http|https):\/\//.test(absUrl)) {
        absUrl = `txvideo://v.qq.com/Html5Activity?url=${encodeURIComponent(absUrl)}`;
      }
      TenvideoJSBridge.invoke(
        'openView',
        {
          url: absUrl,
        },
        () => {
          resolve();
        },
      );
    } catch (e) {
      location.href = url;
      resolve();
    }
  });
});

export default {
  /**
   * 是否腾讯视频APP
   * @return {Boolean} [description]
   */
  isTenvideo() {
    return / QQLiveBrowser\//.test(ua) || / QQLiveHDBrowser\//.test(ua);
  },
  /**
   * 是否小企鹅APP
   * @return {Boolean} [description]
   */
  isKidApp() {
    return / QQLiveKidBrowser\//.test(ua);
  },
  /**
   * 是否定制版APP
   * @return {Boolean} [description]
   */
  isOrderApp() {
    const that = this;
    return new Promise((resolve) => {
      that.checkApi('getAppPayInfo').then(
        (res) => {
          resolve(res.getAppPayInfo);
        },
        () => {
          resolve(false);
        },
      );
    });
  },
  /**
   * 是否APP
   * @return {Boolean} [description]
   */
  isAllTenvideo() {
    return this.isTenvideo() || this.isKidApp();
  },
  /**
   * 判断APP是否支持新的JS API规范
   * @return {Boolean}
   */
  isNewAPI() {
    if (this.isTenvideo()) {
      const info = ua.match(/QQLive(HD)?Browser\/([\d.]+)/);
      if (info && info.length > 1) {
        const ver = info[2];
        if ((isIOS && ver >= '3.9') || ver >= '4.0') {
          return true;
        }
        return false;
      }
      return false;
    } if (this.isKidApp()) {
      return true;
    }
    return false;
  },
  /**
   * APP JS API Ready
   * @param  {Function} 回调方法
   * @return {[type]}
   */
  tenvideoReady,
  /**
   * 拉起登录
   * @param  {string} wx/qq
   * @param  {Function} 回调方法
   * @return {[type]}
   */
  openLogin(type, callback) {
    if (this.isNewAPI()) {
      type = type || 'tv';
      this.tenvideoReady(() => {
        TenvideoJSBridge.invoke(
          'actionLogin',
          {
            type,
          },
          (jsonMsg) => {
            const json = JSON.parse(jsonMsg);
            if (parseInt(json.errCode, 10) === 0) {
              callback && callback(json.result);
            } else {
              callback && callback();
            }
          },
        );
      });
    } else {
      if (isAdr) {
        // Android登录
        let skey = Android.getCookieValue('skey');
        if (!!skey === false) {
          const id = window.setInterval(() => {
            skey = Android.getCookieValue('skey');
            if (skey) {
              window.clearInterval(id);
              const uin = Android.getCookieValue('uin');
              const lskey = Android.getCookieValue('lskey');
              skey = Android.getCookieValue('skey');
              callback
              && callback({
                state: 0,
                data: {
                  uin,
                  skey,
                  lskey,
                },
              });
            }
          }, 500);
        } else {
          const uin = Android.getCookieValue('uin');
          const lskey = Android.getCookieValue('lskey');
          skey = Android.getCookieValue('skey');
          callback
          && callback({
            state: 0,
            data: {
              uin,
              skey,
              lskey,
            },
          });
        }
      } else if (isIOS) {
        _callIosBridge('logInQQ', null, (jsonMsg) => {
          callback && callback(jsonMsg);
        });
      }
    }
  },
  /**
   * 拉起登录
   * @param  {string} wx/qq
   * @param  {Function} 回调方法
   * @return {[type]}
   */
  logout(callback) {
    if (this.isNewAPI()) {
      this.tenvideoReady(() => {
        const param = {
          needBack: false,
        };
        TenvideoJSBridge.invoke('logout', param, (jsonMsg) => {
          const json = JSON.parse(jsonMsg);
          if (parseInt(json.errCode, 10) === 0) {
            callback && callback();
          }
        });
      });
    }
  },

  openUrl(url, close) {
    const that = this;
    return new Promise((resolve) => {
      that.tenvideoReady(() => {
        let absUrl = urlNormalize(_getAbsUrl(url), 'https:');
        try {
          if (env.isLiteApp) {
            if (/^(http|https):\/\//.test(absUrl)) {
              absUrl = `videolite://v.qq.com/H5HollywoodActivity?url=${encodeURIComponent(absUrl)}`;
            }
            TenvideoJSBridge.invoke(
              'openView',
              {
                url: absUrl,
              },
              () => {
                resolve();
              },
            );
            return;
          }
          // 坑爹的iphone 5.0.1之前的版本有url白名单限制，为了兼容处理，对于非qq域的h5页面用openUrl打开
          if (
            /^(http|https):\/\//.test(absUrl)
            && _getHost(absUrl).indexOf('qq.com') === -1
          ) {
            TenvideoJSBridge.invoke(
              'openUrl',
              {
                url: absUrl,
              },
              () => {
                resolve();
              },
            );
            return;
          }
          if (/^(http|https):\/\/(film|pay)\.qq\.com/.test(absUrl)) {
            absUrl = `txvideo://v.qq.com/HollywoodH5Activity?url=${encodeURIComponent(absUrl)}`;
          } else {
            if (/^(http|https):\/\//.test(absUrl)) {
              absUrl = `txvideo://v.qq.com/Html5Activity?url=${encodeURIComponent(absUrl)}`;
            }
          }
          TenvideoJSBridge.invoke(
            'openView',
            {
              url: absUrl,
              close: String(close || 0),
            },
            () => {
              resolve();
            },
          );
        } catch (e) {
          location.href = url;
          resolve();
        }
      });
    });
  },
  openUrlCommonActivity,
  /**
   * 拉起QQ登录(旧方法已过时，请使用openLogin)
   * @param  {Function}
   * @return {[type]}
   */
  loginQQ(callback) {
    this.openLogin('', callback);
  },
  /**
   * 设置分享
   * @param {[type]} 分享参数{title:'',desc:'',imgUrl:'',link:'',singleTitle: ''}
   */
  setShare(param, options = {}) {
    const title = param.title || '腾讯视频VIP影院';
    const desc = param.desc || '享受更好的，因为我是VIP';
    const pic = urlNormalize(
      param.imgUrl || '//puui.qpic.cn/vupload/0/1575447197802_m1krxk6ieeo.png/0',
      false,
    );
    const url = urlNormalize(
      param.link
      || document.location
        .toString()
        .replace(/[?&#](code|state|timestamp)=[^&#]+/gi, ''),
      false,
    );
    const shareInfo = {
      title, subTitle: desc, imageUrl: pic, url,
    };
    if (param.singleTitle) {
      shareInfo.singleTitle = param.singleTitle;
    }

    if (this.isNewAPI()) {
      this.tenvideoReady(() => {
        try {
          TenvideoJSBridge.invoke('setMoreInfo', {
            hasRefresh: true,
            hasShare: true,
            hasFollow: false,
            shareInfo,
            ...options,
          });
        } catch (err) {}
      });
    } else {
      if (isAdr) {
        try {
          window.Android.isShowShareNotifyBar(1, 0);
          window.Android.goShare(title, pic, url);
        } catch (ex) {}
      } else {
        try {
          window.isWarn = 0;
          window.isShare = 1;
          window.shareTitle = title;
          window.shareSubTitle = desc;
          window.shareImageURL = pic;
          window.shareURL = url;
        } catch (ex) {}
      }
    }
  },
  setOnShareHandler(handler, cancelHandler) {
    this.tenvideoReady(() => {
      TenvideoJSBridge.on('onShareFinish', (res) => {
        let data;
        if (typeof res === 'string') {
          try {
            data = JSON.parse(res);
          } catch (e) {}
        } else if (typeof res === 'object') {
          data = res;
        }
        if (data && parseInt(data.errCode, 10) === 0) {
          handler && handler();
        } else {
          cancelHandler && cancelHandler(data);
        }
      });
    });
  },
  /**
   * 设置分享图片
   */
  setShareImage(imgUrl) {
    const title = '腾讯视频VIP影院';
    const desc = '享受更好的，因为我是VIP';
    const pic = urlNormalize(imgUrl, false);
    const url = urlNormalize(
      document.location
        .toString()
        .replace(/[?&#](code|state|timestamp)=[^&#]+/gi, ''),
      false,
    );

    if (this.isNewAPI()) {
      this.tenvideoReady(() => {
        try {
          TenvideoJSBridge.invoke('setMoreInfo', {
            hasRefresh: true,
            hasShare: true,
            hasFollow: false,
            isShareImageOnly: true, // 设置YES，可以分享图片，而不是H5
            shareInfo: {
              title,
              subTitle: desc,
              imageUrl: pic,
              url,
            },
          });
        } catch (err) {}
      });
    } else {
      if (isAdr) {
        try {
          window.Android.isShowShareNotifyBar(1, 0);
          window.Android.goShare(title, pic, url);
        } catch (ex) {}
      } else {
        try {
          window.isWarn = 0;
          window.isShare = 1;
          window.shareTitle = title;
          window.shareSubTitle = desc;
          window.shareImageURL = pic;
          window.shareURL = url;
        } catch (ex) {}
      }
    }
  },
  /**
   * 隐藏More菜单
   * @return {[type]} [description]
   */
  hideMore() {
    this.tenvideoReady(() => {
      try {
        TenvideoJSBridge.invoke('setMoreInfo', {
          hasRefresh: false,
          hasShare: false,
          hasFollow: false,
        });
      } catch (err) {}
    });
  },

  /**
   * 显示More菜单
   */
  showMore() {
    this.tenvideoReady(() => {
      try {
        TenvideoJSBridge.invoke('setMoreInfo', {
          hasRefresh: true,
          hasShare: true,
          hasFollow: true,
        });
      } catch (err) {}
    });
  },
  /**
   * 判断是否安装腾讯视频APP
   * @param  {Function} 安装回调
   * @param  {Function} 未安装回调
   */
  isAppInstalled(tCb, fCb) {
    if (ua.indexOf('MicroMessenger') >= 0) {
      let packageName = '';
      let packageUrl = '';
      if (isIOS) {
        packageName = 'com.tencent.live4iphone';
        packageUrl =          'tenvideo2://can_open_me_if_install_and_regeister_this_scheme';
      } else if (isIPad) {
        packageName = 'com.tencent.QQLiveHD';
        packageUrl =          'tenvideohd://can_open_me_if_install_and_regeister_this_scheme';
      } else {
        // aphone
        packageName = 'com.tencent.qqlive';
        packageUrl =          'tenvideo://can_open_me_if_install_and_regeister_this_scheme';
      }
      setTimeout(() => {
        window.WeixinJSBridge
        && WeixinJSBridge.invoke(
          'getInstallState',
          {
            packageName,
            packageUrl,
          },
          (n) => {
            const o = n.err_msg;
            if (o.indexOf('get_install_state:yes') > -1) {
              tCb && tCb();
            } else {
              fCb && fCb();
            }
          },
        );
      }, 100);
    } else {
      util.loadScript(
        'qqapi',
        '//pub.idqqimg.com/qqmobile/qqapi.js?_bid=152&max_age=31104000',
        () => {
          mqq.device.isMobileQQ((isQQ) => {
            if (isQQ) {
              let name = '';
              if (isIOS) {
                name = 'tenvideo2';
              } else if (isIPad) {
                name = 'tenvideohd';
              } else {
                name = 'com.tencent.qqlive';
              }
              mqq.app.isAppInstalled(name, (isInstall) => {
                const isInstallBoolean = (typeof isInstall === 'boolean') && isInstall;
                const isInstallObject = (typeof isInstall === 'object') && isInstall && isInstall.result;
                if (isInstallBoolean || isInstallObject) {
                  tCb && tCb();
                } else {
                  fCb && fCb();
                }
              });
            } else {
              tCb && tCb();
            }
          });
        },
      );
    }
  },
  /**
   * 获取当前主登录帐号的用户信息
   * @param suCb
   * @param failCb
   */
  getMainUserInfo(suCb, failCb) {
    this.tenvideoReady(() => {
      TenvideoJSBridge.invoke('getMainUserInfo', null, (jsonMsg) => {
        const json = JSON.parse(jsonMsg);
        if (parseInt(json.errCode, 10) === 0) {
          suCb && suCb(json.result);
        } else {
          failCb && failCb();
        }
      });
    });
  },
  /**
   * 打开分享窗口
   *【注：分享的参数需要事先调setMoreInfo设置好】
   * @return {[type]} [description]
   */
  openShare() {
    this.tenvideoReady(() => {
      try {
        TenvideoJSBridge.invoke('openToolsDialog', null);
      } catch (err) {}
    });
  },
  /**
   * 拉起APP支付
   * @param  {[type]} param [description]
   * @return {[type]}       [description]
   */
  openPay(param) {
    this.tenvideoReady(() => {
      try {
        let payType = 'openPay';
        if (param.product_type === 'day') {
          payType = 'openPayByDay';
        }
        TenvideoJSBridge.invoke(payType, param);
      } catch (err) {}
    });
  },
  /**
   * 拉起单点支付
   */
  openPaySingle(param, callback) {
    const appVer = this.getAppVersion();
    this.tenvideoReady(() => {
      try {
        if (appVer >= '5.2.1') {
          if (appVer === '5.2.1') {
            callback
            && callback({
              msg: 'refresh',
            });
          }
          TenvideoJSBridge.invoke('openPaySingle', param, (res) => {
            if (typeof res === 'string') {
              // 透传jsapi支付结果
              const json = JSON.parse(res);
              if (json && json.paySucc === 1) {
                callback
                && callback(extend({
                  msg: 'succ',
                }, json));
              } else {
                callback
                && callback(extend({
                  msg: 'payFailed',
                }, json));
              }
            }
          });
        } else {
          callback
          && callback({
            msg: 'download',
          });
        }
      } catch (e) {
        callback
        && callback({
          msg: 'tenvideoFailed',
        });
      }
    });
  },
  /**
   * 获取APP信息
   * @param  {Function} callback [description]
   * @return {[type]}            [description]
   */
  getAppInfo(callback) {
    let isCallback = false;
    const appInfo = Storage.getJSON('app_info');
    if (appInfo) {
      isCallback = true;
      callback && callback(appInfo);
    }
    this.tenvideoReady(() => {
      try {
        TenvideoJSBridge.invoke('getAppInfo', null, (jsonMsg) => {
          const json = JSON.parse(jsonMsg);
          if (parseInt(json.errCode, 10) === 0) {
            Storage.setJSON('app_info', json.result);
            !isCallback && callback && callback(json.result);
          } else {
            !isCallback && callback && callback();
          }
        });
      } catch (err) {}
    });
  },
  /**
   * 获取APP版本信息
   */
  getAppVersion() {
    let versionCode = '';
    if (this.isAllTenvideo()) {
      let posBrowser = ua.indexOf('QQLiveBrowser');
      if (this.isKidApp()) {
        posBrowser = ua.indexOf('QQLiveKidBrowser');
      }
      const tmp = ua.substring(posBrowser);
      const arrRtn = tmp.split('/');
      if (arrRtn.length >= 2) {
        const verTmp = arrRtn[1];
        const verTmpArr = verTmp.split('.');
        if (isAdr) {
          if (verTmpArr.length >= 4) {
            versionCode = [
              verTmpArr[0],
              '.',
              verTmpArr[1],
              '.',
              verTmpArr[2],
            ].join('');
          }
        } else {
          versionCode = verTmp;
        }
      }
    }
    return versionCode;
  },
  /**
   *@duplicate getAppVersion
   */
  getVersion() {
    if (!this.isAllTenvideo()) {
      return '';
    }
    const matches = ua.match(/(?:QQLiveBrowser|QQLiveKidBrowser|QQLiveHDBrowser)\/(\d+\.\d+\.\d+)/);
    return matches && matches.length >= 2 ? matches[1] : '';
  },
  /**
   * 切换帐号
   */
  switchLogin(type, callback) {
    this.tenvideoReady(() => {
      try {
        TenvideoJSBridge.invoke(
          'switchLoginState',
          {
            userType: type,
          },
          () => {
            TenvideoJSBridge.on('onSwitchLoginStateResponse', (ret) => {
              if (isIOS) {
                ret = JSON.parse(ret);
              }
              if (ret && parseInt(ret.errCode, 10) === 0) {
                callback && callback();
              }
            });
          },
        );
      } catch (err) {}
    });
  },

  isNewSdkVersion() {
    let isNew = false;
    if (isIOS && this.versionCompare(this.getAppVersion(), '4.5.5')) {
      isNew = true;
    } else if (isAdr && this.versionCompare(this.getAppVersion(), '4.6.0')) {
      isNew = true;
    }
    return isNew;
  },
  /**
   * 版本号比较X.X.X
   */
  versionCompare(version1, version2) {
    const v1Array = version1.split('.');
    const v2Array = version2.split('.');
    let result = false;
    if (v1Array.length === v2Array.length && v1Array.length > 2) {
      for (let i = 0; i < v1Array.length; i++) {
        const item1 = v1Array[i];
        const item2 = v2Array[i];
        const num1 = parseInt(item1, 10);
        const num2 = parseInt(item2, 10);
        if (num1 > num2) {
          result = true;
          break;
        } else if (num1 < num2) {
          result = false;
          break;
        } else {
          result = true;
        }
      }
    }
    return result;
  },
  /**
   * 获取定制版app信息
   */
  getAppPayInfo() {
    const that = this;
    return new Promise((resolve, reject) => {
      that.tenvideoReady(() => {
        try {
          TenvideoJSBridge.invoke('getAppPayInfo', null, () => {
            resolve();
          });
        } catch (e) {
          reject(e);
        }
      });
    });
  },
  /**
   * 判断当前客户端版本是否支持指定JS接口
   */
  checkApi(api) {
    const that = this;
    let apiList = [];
    if (isArray(api)) {
      apiList = api;
    } else {
      apiList.push(api);
    }
    return new Promise((resolve, reject) => {
      that.tenvideoReady(() => {
        try {
          TenvideoJSBridge.invoke(
            'checkApi',
            {
              apiList,
            },
            (res) => {
              if (res && parseInt(res.errCode, 10) === 0) {
                resolve(res.result);
              } else {
                reject(res);
              }
            },
          );
        } catch (e) {
          reject(e);
        }
      });
    });
  },
  /**
   * 刷新标题接口
   * @param title
   */
  refreshTitle(title) {
    this.tenvideoReady(() => {
      try {
        TenvideoJSBridge.invoke('refreshTitle', {
          title,
        });
      } catch (err) {}
    });
  },
  /**
   *
   * @param base64 前端生成的图片base64
   * App 6.0.0及版本以上支持分享本地图片，6.0.0以下则采用先上传，拿到url后分享图片
   */

  shareLocalImage(base64Str, callback) {
    const that = this;
    that.tenvideoReady(() => {
      try {
        if (that.canUseShareLocalImage()) {
          TenvideoJSBridge.invoke(
            'shareLocalImage',
            {
              // 客户端要求去掉toDataUrl默认生成的base64头，传纯base64字符串即可
              imgbase64String: base64Str.replace(
                /^data:image\/(png|jpeg|webp);base64,/,
                '',
              ),
            },
            (jsonMsg) => {
              const json = JSON.parse(jsonMsg);
              if (json && parseInt(json.errCode, 10) === 0) {
                callback
                && callback({
                  msg: json.errMsg,
                });
              } else {
                callback
                && callback({
                  msg: 'tenvideoFailed',
                });
              }
            },
          );
        } else {
          _uploadImage(base64Str, (json) => {
            if (
              json
              && parseInt(json.ret, 10) === 0
              && json.result
              && json.result.access
              && json.result.access.length > 0
            ) {
              const picUrl = `${location.protocol}//${json.result.access[0]}`;
              // iOS代码实现有问题，要先调一下saveImage,不论是否成功，收到回调后再调分享图片
              if (isIOS) {
                that.saveImage(picUrl, () => {
                  that.shareImageByUrl(picUrl, (res) => {
                    if (res && parseInt(res.errCode, 10) === 0) {
                      callback
                      && callback({
                        msg: res.errMsg,
                      });
                    } else {
                      callback
                      && callback({
                        msg: 'tenvideoFailed',
                      });
                    }
                  });
                });
              } else {
                that.shareImageByUrl(picUrl, (res) => {
                  if (res && parseInt(res.errCode, 10) === 0) {
                    callback
                    && callback({
                      msg: res.errMsg,
                    });
                  } else {
                    callback
                    && callback({
                      msg: 'tenvideoFailed',
                    });
                  }
                });
              }
            } else {
              callback
              && callback({
                msg: 'uploadImageFailed',
              });
            }
          });
        }
      } catch (e) {
        callback
        && callback({
          msg: 'tenvideoFailed',
        });
      }
    });
  },
  /**
   * hack app shareLocalImage
   */
  canUseShareLocalImage() {
    const version = new Version(this.getVersion());
    if (!version.compare('6.0.0')) {
      return false;
    }
    if (isIOS) {
      return true;
    }
    // hack 安卓6.2.1-6.2.2版本分享bug
    if (version.compare('6.2.1') && !version.compare('6.2.3', false)) {
      return false;
    }
    return true;
  },
  /**
   * 通过图片url分享图片
   * @param picUrl
   * @param callback
   */
  shareImageByUrl(picUrl, callback) {
    this.tenvideoReady(() => {
      try {
        TenvideoJSBridge.invoke(
          'shareLocalImage',
          {
            imageUrl: picUrl,
          },
          (jsonData) => {
            const json = JSON.parse(jsonData);
            if (json && parseInt(json.errCode, 10) === 0) {
              callback && callback(json);
            } else {
              callback
              && callback({
                msg: 'tenvideoFailed',
              });
            }
          },
        );
      } catch (e) {
        callback
        && callback({
          msg: 'tenvideoFailed',
        });
      }
    });
  },
  /**
   * 保存图片到手机
   * @param picUrl
   * @param callback
   */
  saveImage(picUrl, callback) {
    this.tenvideoReady(() => {
      try {
        TenvideoJSBridge.invoke(
          'saveImage',
          {
            url: picUrl,
          },
          (jsonData) => {
            const json = JSON.parse(jsonData);
            if (json && parseInt(json.errCode, 10) === 0) {
              callback && callback(json);
            } else {
              callback
              && callback({
                msg: 'tenvideoFailed',
              });
            }
          },
        );
      } catch (e) {
        callback
        && callback({
          msg: 'tenvideoFailed',
        });
      }
    });
  },
};

/** @description 获取ios的接口
 * @param
  func_suc 获取到ios接口之后的回调函数
 @remark 首先判断ios接口是否存在，如果不存在的话，就监听下接口ready的事件，如果再5秒钟内两者都没有获取到接口，就提示失败
 */
// let iosBridgeDefer = null;

function _iosBridge(funcSuc) {
  funcSuc = funcSuc || function () {};
  if (typeof WebViewJavascriptBridge === 'undefined') {
    if (document.addEventListener) {
      document.addEventListener(
        'WebViewJavascriptBridgeReady',
        () => {
          WebViewJavascriptBridge.init();
          funcSuc();
        },
        false,
      );
    }
  } else {
    WebViewJavascriptBridge.init();
    funcSuc();
  }
}

/** @description 调用IOS的接口
 @param {str} str_method 所使用的接口的名字
 @param {str} str_param 输入的参数
 @param {str} func_suc 调用成功的回调函数
 */

/* eslint camelcase: ["off"] */
function _callIosBridge(str_method, str_param, func_suc) {
  _iosBridge(() => {
    WebViewJavascriptBridge.callHandler(str_method, str_param, (str_msg) => {
      let json_res = {};
      json_res = _parseJSON(str_msg);
      func_suc
      && func_suc({
        state: 0,
        origdata: str_msg,
        data: json_res,
      });
    });
  });
}

/*
 * Android中调用接口的逻辑
 * @param
 *      handleName 要调用的接口名
 *      json_param 参数
 */

// function _callAndroidBridge(handleName, json_param) {
//   let str_msg = "";
//   let json_result = {
//     state: 0
//   };
//   try {
//     if (json_param) {
//       let str_param = json_param;
//       if (typeof str_param == "object") {
//         str_param = JSON.stringify(str_param);
//       }
//       str_msg = Android[handleName](str_param);
//     } else {
//       str_msg = Android[handleName]();
//     }
//     json_result.origdata = str_msg;
//   } catch (e) {
//     json_result.state = 1;
//     json_result.msg = `Bridge Error(${handleName})`;
//   }
//   return json_result;
// }

/**
 * @descripton 解析JSON数据
 */
function _parseJSON(str_json) {
  let json_msg = null;
  try {
    json_msg = JSON.parse(str_json);
  } catch (e) {
    json_msg = null;
  }
  return json_msg;
}

function _getAbsUrl(url) {
  if (!/^(https:|http:)/.test(location.protocol) && /^\/\//.test(url)) {
    return `https:${url}`;
  }
  const a = document.createElement('a');
  a.href = url;
  return a.href;
}

function _getHost(url) {
  let host = '';

  let oUrl;
  try {
    oUrl = new URL(url);
    host = oUrl.host;
  } catch (e) {
    // console.warn("[tenvideo._getHost]", e.message);
  }
  return host;
}

/**
 * 图片上传
 * @param base64
 * @private
 */
function _uploadImage(base64, callback) {
  $.ajax({
    url: `${location.protocol}//node.video.qq.com/x/services/imageupload`,
    type: 'POST',
    data: {
      base64,
    },
    // contentType: false,
    // processData: false,
    xhrFields: {
      withCredentials: true,
    },
    success(json) {
      callback && callback(json);
    },
  });
}
